class Auth {
  constructor() {
    this.authInfo = null;
  }

  setAuth(authInfo) {
    this.authInfo = authInfo;
    localStorage.setItem('authInfo', JSON.stringify(authInfo));
  }

  getAuth() {
    return this.authInfo || JSON.parse(localStorage.getItem('authInfo'));
  }

  getCompanyDomain() {
    const authInfo = this.getAuth();

    const primaryDomain = authInfo?.company?.domains?.find(
      domain => domain.is_primary,
    )?.domain;

    return primaryDomain || 'neillp';
  }

  isAuthenticated() {
    return !!this.getAuth();
  }

  isAdmin() {
    return this.getAuth()?.is_admin || false;
  }

  isSuperuser() {
    return this.getAuth()?.is_superuser || false;
  }

  getCompany() {
    return this.getAuth()?.company;
  }

  clearAuth() {
    this.authInfo = null;
    localStorage.removeItem('authInfo');
    localStorage.removeItem('selectedWarehouse');
  }
}

export default new Auth();
